export enum LightType {
	AREA = 'areaLight',
	DIRECTIONAL = 'directionalLight',
	HEMISPHERE = 'hemisphereLight',
	POINT = 'pointLight',
	PROBE = 'lightProbe',
	SPOT = 'spotLight',
}
export enum THREELightType {
	AREA = 'AreaLight',
	DIRECTIONAL = 'DirectionalLight',
	HEMISPHERE = 'HemisphereLight',
	POINT = 'PointLight',
	SPOT = 'SpotLight',
}
